import styled from "styled-components";
import Colors from "../../constants/Colors";

export const CalendarAnchor = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin-left: 10px;
  text-align: center;
  padding: 10px 14px;
  align-items: center;
  justify-content: space-between;
  width: ${props => (props.isMobile ? "100%" : "250px")};
  border-radius: 8px;
  background-color: ${Colors.SPM50};
  border: 1px solid ${Colors.SPM100};
`;

export const HourContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 40px;
  background-color: #0000000d;
  border-radius: 4px;
`;
export const FilterContainer = styled.div`
  width: 200px;
  height: 150px;
  padding: 10px 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.5);
`;
export const FilterOptionContainer = styled.div`
  flex-direction: row;
  display: flex;
  margin-bottom: 2px;
`;
//flexDirection: 'row', width: '100%', display: 'flex', justifyContent: 'space-evenly'
export const ListHeaderContainer = styled.div`
  flex-direction: row;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
`;
//width: '100%', textAlign: 'center' }
export const ListHeaderItemContainer = styled.div`
  width: 100%;
  text-align: center;
`;
////width: '100%', alignItems: 'center', alignSelf: 'center', justifyContent: 'center', flexDirection: 'row', display: 'flex'

export const ListHeaderItemWithFilterContainer = styled.div`
  width: 100%;
  align-items: center;
  align-self: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
`;
//{ width: '90%', flexDirection: isMobile ? 'column' : 'row', display: 'flex', justifyContent: 'space-between' }
export const CalendarRowContainer = styled.div<{ isMobile?: boolean }>`
  width: 90%;
  flex-direction: ${props => (props.isMobile ? "column" : "row")};
  display: flex;
  justify-content: space-between;
`;

export const AppointmentStatusFilterContainer = styled.div`
  width: 220px;
  height: 250px;
  padding: 5px 10px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.5);
`;

export const MobileContainer = styled.div<{ disabled?: boolean }>`
  background-color: ${props => (props.disabled ? "#F9FAFB66;" : Colors.GRAY50)};
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 10px;
  margin-bottom: 15px;
`;

export const AppointmentStatusContainer = styled.div<{ isSelected: boolean }>`
  flex-direction: row;
  display: flex;
  padding-left: 5px;
  background-color: ${props => (props.isSelected ? Colors.SPM200 : "")};
  margin-bottom: 2px;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background-color: ${Colors.GRAY200};
  }
`;
export const PersonalData = styled.div<{
  isMobile?: boolean;
}>`
  max-width: ${props => (props.isMobile ? "70%" : "600px")};
  column-gap: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const TextualData = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
`;

export const InputFullGray = styled.input<{
  isMobile?: boolean;
  isValid?: boolean;
}>`
  width: ${props => (props.isMobile ? "95%" : "200px")};
  position: relative;
  height: 10px;
  border-radius: 8px;
  padding: 10px 30px 10px 14px;

  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #101828;
  bottom: 10px;

  &:focus {
    outline: none;
  }
`;

export const PatientData = styled.div<{ isMobile?: boolean }>`
  flex-direction: ${props => (props.isMobile ? "column" : "row")};
  display: flex;
  align-items: flex-start;
`;

export const Img = styled.img`
  margin-top: 15px;
  height: 200px;
  width: 200px;
  border-radius: 10px;
`;

export const Menu = styled.div<{ isMobile?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isMobile }) =>
    isMobile ? "100%" : " 170px 250px 170px 180px"};
  grid-template-rows: 2;
  border: 1px solid #e3e3e6;
  margin-bottom: 10px;
  align-items: ${props => (props.isMobile ? "flex-start" : "none")};
`;
export const ButtonMenu = styled.button<{ color?: string; selected?: boolean }>`
  background: none;
  border: none;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;

  color: ${props => (props.color ? props.color : "#0d6cbf")};
  border-bottom: ${props =>
    props.selected && props.color
      ? `2px solid ${Colors.cancel}`
      : props.selected
      ? `2px solid ${Colors.SPM400}`
      : "none"};

  padding: 15px;

  cursor: pointer;
`;

export const Content = styled.div<{ isMobile?: boolean }>``;
export const ContainerTopics = styled.div<{ isMobile?: boolean }>`
  width: ${props => (props.isMobile ? "90vw" : "800px")};
`;
